/**
 * White-listed partner URL params.
 */
export const PartnerParams = {
  global: ['nm', 'ph', 'clickID'],
  user: ['code'],
  // Below are not partners but our direct paid channel.
  // Piggybacks as partner params to control feature enablements for paid channels.
  facebook: [],
  googlebrand: [],
  tiktok: [],
  youtube: [],
  qw: ['fname', 'lname', 'campaignID'],
  everquote: ['fname', 'lname', 'campaignID'],
  kissterra: ['fname', 'lname', 'state'],
  smartfinancial: ['fname', 'lname', 'state'],
  // Partner list.
  // Please maintain alphabetical order.
  acorns: ['irclickid'],
  af247: ['utm_campaign'],
  benzinga: [],
  beenverified: ['utm_campaign'],
  billfixers: [],
  brightsidefinancial: ['campaignID'],
  bulldogmedia: ['AFFID', 'CAMPID'],
  bumper: [],
  cbautogroup: ['utm_campaign'],
  chime: ['utm_campaign', 'userID'],
  consnet: ['utm_campaign'],
  copilot: ['utm_campaign'],
  credible: [],
  creditcom: ['clickid', 'tid'],
  dmv: [],
  edriving: ['utm_campaign', 'fname', 'lname', 'FICO'],
  empowerdirect: [],
  ensured365: ['campaignID'],
  experian: ['utm_campaign', 'subid'],
  ezauto: [],
  fg: ['utm_campaign', 'clickid'],
  fiona: ['fname', 'lname'],
  gigsharks: [],
  hellopocket: ['campaignid'],
  internetbrands: ['utm_campaign', 'fname', 'lname'],
  iseecars: [],
  jobble: [],
  jobget: [],
  kiplinger: [],
  lyft: [],
  maxbounty: ['subID'],
  mediaalpha: ['utm_publisher', 'fname', 'lname'],
  mint: ['utm_campaign'],
  moneycrashers: [],
  makingsenseofcents: [],
  moneysmart: [],
  mykukun: ['utm_campaign'],
  nerdwallet: ['zip'],
  nonda: [],
  penny: ['utm_campaign', 'tid'],
  performcb: ['linkID', 'cbtid'],
  prodege: ['tid'],
  prodigy: ['campaignID'],
  ratemarketplace: ['affId', 'fname', 'lname'],
  realworld: [],
  recoup: [],
  theweek: [],
  self: ['utm_campagin'],
  spotangels: ['utm_campaign', 'fname', 'lname'],
  steady: [],
  stash: ['utm_campaign', 'fname', 'lname'],
  stellarfi: ['campaignID'],
  superiorautogroup: ['campaignID'],
  wardinsurancegroup: [],
  winit: [],
  wonolo: [],
  zac3: ['cid', 'rid'],
  carsandbids: [],
  transparently: [],
  quinstreet: [],
  gasbuddy: ['utm_publisher', 'fname', 'lname'],
  gasbuddyapp: ['utm_publisher', 'fname', 'lname'],
  gasbuddyemail: ['utm_publisher', 'fname', 'lname'],
  gasbuddyalt: ['utm_publisher', 'fname', 'lname'],
};

export type PartnerName = Exclude<keyof typeof PartnerParams, 'global'>;

/**
 * These are not partners but treated as marketing or affiliate channels.
 * Need special check for these sources since it won't have the prefix 'p' like normal partners.
 */
export const PARTNER_PAID_CHANNEL: PartnerName[] = [
  'facebook',
  'tiktok',
  'youtube',
  'googlebrand',
  'qw',
  'everquote',
  'kissterra',
  'smartfinancial',
  'gasbuddy',
  'gasbuddyapp',
  'gasbuddyemail',
  'gasbuddyalt',
];
export interface PartnerData {
  code: string;
  partner: PartnerName;
  data: Record<string, string>;
}

export type ConversionEvent = 'onboarded';

export type ReportConversionFunction = (
  event: ConversionEvent,
  partnerData: PartnerData,
  sessionID?: string | null
) => void;

export enum InternalSource {
  SEO = 'seo',
  Default = 'default',
}
